"use client";

import React, { useRef } from "react";
import { ArrowUpRight, ChevronLeft, ChevronRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const ministriesData = [{
  id: 1,
  title: "MINISTERIO A LOS HOMBRES",
  description: "Capacitamos a los hombres para que sean siervos maduros en sus familias, comunidades e iglesias a través de la hermandad, la tutoría y el crecimiento espiritual.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/men_ministry_group.webp",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/men_ministry_group.webp-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/men_ministry_group.webp-wvc-sizes",
  alt: "Grupo del ministerio de hombres conversando",
  link: "#"
}, {
  id: 2,
  title: "MINISTERIO A LAS MUJERES",
  description: "Animamos y capacitamos a las mujeres para que cumplan su llamado y tengan un impacto en el mundo a través de la fe, el servicio y el liderazgo.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/women_ministry_fellowship.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/women_ministry_fellowship.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/women_ministry_fellowship.png-wvc-sizes",
  alt: "Mujeres sonriendo y compartiendo en comunidad",
  link: "#"
}, {
  id: 3,
  title: "MINISTERIO A LOS JÓVENES ADULTOS",
  description: "Ayudamos a los jóvenes adultos a escuchar la voz de Dios, a descubrir su propósito y a vivir su vocación.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/young_adults_ministry.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/young_adults_ministry.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/young_adults_ministry.png-wvc-sizes",
  alt: "Grupo de jóvenes adultos alegres reunidos",
  link: "#"
}, {
  id: 4,
  title: "MINISTERIO A LOS ADULTOS MAYORES",
  description: "Proporcionamos oportunidades de enriquecimiento espiritual, conexión social y servicio impactante para personas de 55 años o más.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/senior_adults_ministry.webp",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/senior_adults_ministry.webp-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/senior_adults_ministry.webp-wvc-sizes",
  alt: "Adultos mayores compartiendo sonrientes",
  link: "#"
}];
export default function Ministriesgrid() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const shouldReduceMotion = useReducedMotion();
  const handleScroll = (direction: "left" | "right") => {
    if (!scrollContainerRef.current) return;
    const scrollAmount = 340;
    scrollContainerRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth"
    });
  };
  return <section id="ministriesgrid" data-nav="light" className="relative w-full bg-background py-12 md:py-16 lg:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        {}
        <div className="mb-8 flex items-center justify-between md:mb-12">
          <h2 className="text-2xl font-bold tracking-tight text-foreground uppercase sm:text-3xl lg:text-4xl">
            ADULTOS Y FAMILIAS
          </h2>

          {}
          <div className="hidden items-center gap-2 lg:flex">
            <Button variant="outline" size="icon" className="size-10 rounded-full border-border/80 bg-background/80 text-foreground shadow-xs transition-colors hover:bg-accent hover:text-accent-foreground" onClick={() => handleScroll("left")} aria-label="Desplazar a la izquierda">
              <ChevronLeft className="size-5" />
            </Button>
            <Button variant="outline" size="icon" className="size-10 rounded-full border-border/80 bg-background/80 text-foreground shadow-xs transition-colors hover:bg-accent hover:text-accent-foreground" onClick={() => handleScroll("right")} aria-label="Desplazar a la derecha">
              <ChevronRight className="size-5" />
            </Button>
          </div>
        </div>

        {}
        <div className="relative">
          {}
          <div className="pointer-events-none absolute inset-y-0 -left-4 z-20 flex items-center lg:hidden">
            <Button variant="default" size="icon" className="pointer-events-auto size-9 rounded-full bg-foreground/75 text-background shadow-md transition-transform hover:scale-105 hover:bg-foreground" onClick={() => handleScroll("left")} aria-label="Desplazar a la izquierda">
              <ChevronLeft className="size-4" />
            </Button>
          </div>
          <div className="pointer-events-none absolute inset-y-0 -right-4 z-20 flex items-center lg:hidden">
            <Button variant="default" size="icon" className="pointer-events-auto size-9 rounded-full bg-foreground/75 text-background shadow-md transition-transform hover:scale-105 hover:bg-foreground" onClick={() => handleScroll("right")} aria-label="Desplazar a la derecha">
              <ChevronRight className="size-4" />
            </Button>
          </div>

          {}
          <div ref={scrollContainerRef} className="flex snap-x snap-mandatory gap-5 overflow-x-auto pb-4 scrollbar-none sm:gap-6 lg:grid lg:grid-cols-4 lg:gap-6 lg:overflow-visible lg:pb-0">
            {ministriesData.map((item, i) => <motion.div key={item.id} data-index={i} initial={shouldReduceMotion ? {
            opacity: 1
          } : {
            opacity: 0,
            y: 24
          }} whileInView={shouldReduceMotion ? {
            opacity: 1
          } : {
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: "-50px"
          }} transition={{
            duration: 0.5,
            delay: i * 0.1,
            ease: [0.21, 0.47, 0.32, 0.98]
          }} className="group relative flex h-[480px] w-[82vw] shrink-0 snap-center flex-col justify-between overflow-hidden rounded-2xl bg-card shadow-md transition-all duration-300 hover:shadow-xl sm:w-[320px] md:h-[500px] lg:h-[520px] lg:w-auto">
                {}
                <div className="absolute inset-0 z-0">
                  <img src={item.image} data-wvc-srcset={item.imageSrcset} data-wvc-sizes={item.imageSizes} alt={item.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/10" />
                </div>

                {}
                <div className="relative z-10 flex justify-end p-4 sm:p-5">
                  <Link to={item.link} aria-label={`Ver detalles de ${item.title}`} className="inline-flex size-10 items-center justify-center rounded-full bg-background text-foreground shadow-md transition-all duration-300 hover:scale-110 hover:bg-secondary hover:text-secondary-foreground">
                    <ArrowUpRight className="size-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </Link>
                </div>

                {}
                <div className="relative z-10 p-3 sm:p-4">
                  <div className="flex flex-col justify-between rounded-xl bg-background p-4 shadow-md transition-colors sm:p-5">
                    <div>
                      <h3 className="text-base font-bold tracking-tight text-foreground uppercase sm:text-lg">
                        {item.title}
                      </h3>
                      <p className="mt-2 line-clamp-3 text-xs leading-relaxed text-muted-foreground sm:text-sm">
                        {item.description}
                      </p>
                    </div>

                    <div className="mt-4 pt-1">
                      <Link to={item.link} className="inline-block">
                        <Button variant="default" size="sm" className="h-8 rounded-full bg-foreground px-4 text-xs font-semibold uppercase tracking-wider text-background shadow-xs transition-colors hover:bg-foreground/90 hover:text-background">
                          <span>MÁS INFORMACIÓN</span>
                          <ArrowUpRight className="size-3.5" />
                        </Button>
                      </Link>
                    </div>
                  </div>

                  {}
                  <div className="mt-2 h-1.5 w-full rounded-full bg-secondary" />
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}